import React from "react";
import { FaClipboardList, FaBox } from "react-icons/fa";

const Ticket = ({ code, date, type, shipment, destination, onClick }) => {
  return (
    <div className="ticket" onClick={onClick}>
      <div
        style={{
          paddingBottom: 10,
          borderBottom: 1,
          borderBottomStyle: "dashed",
          borderColor: "#848484",
          marginBottom: 10,
        }}
      >
        <div className="d-flex flex-row align-items-center justify-content-between">
          <div
            style={{
              fontWeight: "bold",
              fontSize: 12,
              marginBottom: 5,
            }}
          >
            {code}
          </div>
          <div className="page-pretitle">{date}</div>
        </div>
        <div className="d-flex flex-row align-items-center">
          <FaClipboardList size={14} color="#848484" />
          <div className="text-capitalize ms-1" style={{ fontSize: 12 }}>
            {type?.replace("_", " ")?.replace("console", "transit")}
          </div>
        </div>
      </div>
      <div className="leftBuble" />
      <div className="rightBuble" />
      <div>
        <div className="d-flex flex-row align-items-start">
          <FaBox size={13} color="#2f83ba" />
          <div className="text-capitalize ms-1">
            <div className="fw-bold" style={{ fontSize: 12 }}>
              {shipment}
            </div>
            <div style={{ fontSize: 12 }}>{destination}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ticket;
